import { IVideoLayer, IVideoLayerInDTO, VideoLayerPlaybackStrategyEnum } from './video-layer-model';
import { IStagePositionsExtended } from '../../../defines';

export class VideoLayerUtils {
    constructor(private videoLayer: IVideoLayer) {}
    public getIsBackgroundVL() {
        const { position, id } = this.videoLayer.videoPosition;

        return id === 'default';
    }

    public static getIsBackgroundPosition(stagePosition: IStagePositionsExtended) {
        return stagePosition.id === 'default';
    }
    public static sortVideoLayersByPosition(videoLayers: IVideoLayer[]) {
        videoLayers.sort((a, b) => {
            const isDefaultA = VideoLayerUtils.getIsBackgroundPosition(a.videoPosition);
            const isDefaultB = VideoLayerUtils.getIsBackgroundPosition(b.videoPosition);

            // If one is default and the other isn't, place default first
            if (isDefaultA !== isDefaultB) {
                return isDefaultA ? -1 : 1;
            }

            // Compare by area (smaller area first or larger first — your choice)
            const areaA = (a?.videoPosition?.width ?? 0) * (a.videoPosition?.height ?? 0);
            const areaB = (b.videoPosition?.width ?? 0) * (b.videoPosition?.height ?? 0);

            // Example: larger area below, smaller area above
            return areaB - areaA;
        });
    }

    public static async playbackMediaByPlaybackStrategyAsync(
        trimStartAsSeconds: number,
        trimEndAsSeconds: number,
        mediaPlayer: HTMLMediaElement,
        playbackStrategy: VideoLayerPlaybackStrategyEnum,
        uniqueId: string
    ) {
        const trimStart = trimStartAsSeconds ?? 0;
        const trimEnd = trimEndAsSeconds ?? 0;
        const effectiveEnd = mediaPlayer.duration - trimEnd;
        if (mediaPlayer.currentTime >= effectiveEnd - 0.05) {
            if (playbackStrategy === VideoLayerPlaybackStrategyEnum.LOOP_VIDEO) {
                // restart at trimmed start
                mediaPlayer.currentTime = trimStart;
                try {
                    await mediaPlayer.play();
                } catch (error) {
                    console.warn(`Video ${uniqueId} failed to loop play:`, error);
                }
            } else if (playbackStrategy === VideoLayerPlaybackStrategyEnum.LAST_FRAME_FREEZE) {
                mediaPlayer.currentTime = effectiveEnd - 0.05; // freeze at trimmed end
                mediaPlayer.pause();
                console.log(`Video ${uniqueId} frozen at trimmed end`);
            }
        }
    }
}
